import { Routes } from '@angular/router';
import { TimeTrackingComponent } from './components/time-tracking/time-tracking.component';

export const TIME_TRACKING_ROUTES: Routes = [
  { path: 'time-tracking', component: TimeTrackingComponent },
];
